import { createWebSocketStore } from 'src/components/#services/helpers';
export const allLigament = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_getAllByFilter',
    },
});
export const allTokens = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'token_getAll',
    },
});
export const ligamentInfo = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_getById',
    },
});
export const tokenInfo = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'token_get',
    },
});
export const updateLigamentPriorityIndex = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_updatePriorityIndex',
    },
});
export const updateLigament = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_update',
    },
});
export const updateToken = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'token_update',
    },
});
export const createLigament = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_add',
    },
});
export const addToken = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'token_create',
    },
});
export const deleteLigament = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'ligament_remove',
    },
});
export const deleteToken = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'token_delete',
    },
});
export const swapTransactions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'crypto-market',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'swap_getAllByFilter',
    },
});
